export default __webpack_public_path__ + "static/media/hht1_ep4_minisitcom_04.5ec9d96b.png";